import * as React from "react";
import { withIntl } from "@grandvisionhq/state";
const AdyenPaymentCardSummary = ({ info, intl }) => {
  if (!info || !("creditcardBin" in info) || typeof info.creditcardBin !== "string") {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "checkout-payment-info__label" }, intl.getLabel("checkout.creditcard.cardNumber")), /* @__PURE__ */ React.createElement("div", { className: "checkout-payment-info__value" }, info.creditcardBin.substr(0, 4), " **** **** ****"));
};
const CardSummary = withIntl(AdyenPaymentCardSummary);
export {
  AdyenPaymentCardSummary,
  CardSummary as default
};
//# sourceMappingURL=AdyenPaymentCardSummary.js.map
